var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19988 0.199219L0.379883 3.01922L3.49988 6.13922C3.19988 6.69922 3.01988 7.31922 3.01988 7.99922L2.99988 31.9992C2.99988 34.1992 4.79988 35.9992 6.99988 35.9992H33.3399L39.9599 42.6192L42.7799 39.7992L3.19988 0.199219ZM6.99988 31.9992V9.65922L29.3399 31.9992H6.99988Z",
    fill: "#CBDFF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9999 8H22.9999L18.9999 4H13.3399L21.3399 12H38.9999V30.34L42.5199 33.86C42.8199 33.3 42.9999 32.68 42.9999 32V12C42.9999 9.8 41.1999 8 38.9999 8Z",
    fill: "#CBDFF2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.a843a36e0a08b45c11545b9a805e5828.svg";
export { ForwardRef as ReactComponent };